/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import apiClient from "./../../../apiClient";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from "@mui/icons-material/Delete";

const fetchCouponData = async () => {
  const columns = [
    { Header: "Coupon Code", accessor: "couponCode", width: "25%", align: "left" },
    { Header: "Discount", accessor: "discount", align: "left" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "Expiration Date", accessor: "expiry_date", align: "center" },
    { Header: "Description", accessor: "description", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  try {
    const response = await apiClient.get("/admin/coupouns");
    const data = response.data;
    if (data) {
      console.log("coupouns data:", response.data);
      const handleDelete = async (id) => {
        try {
          await apiClient.delete(`/admin/coupouns/${id}`);
          // Refresh data or handle success
        } catch (error) {
          console.error("Error deleting coupouns:", error);
        }
      };
      const handleActivate = async (id) => {
        try {
          await apiClient.put(`/admin/coupouns/${id}`, { status: "Active" });
          // Refresh data or handle success
        } catch (error) {
          console.error("Error activating coupouns:", error);
        }
      };

      const handleEdit = (id) => {
        // Handle edit functionality, e.g., open a dialog with the form
      };

      const rows = data.map((data) => ({
        couponCode: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data.couponCode}
          </MDTypography>
        ),
        discount: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data.discount}
          </MDTypography>
        ),
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={data.status}
              color={data.status === "Active" ? "success" : "warning"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        expiry_date: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data.expiry_date}
          </MDTypography>
        ),
        description: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {data.description}
          </MDTypography>
        ),
        action: (
          <MDBox display="flex" justifyContent="space-around">
            <IconButton onClick={() => handleEdit(data._id)} color="secondary">
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => handleActivate(data._id)} color="success">
              <CheckCircleIcon />
            </IconButton>
            <IconButton onClick={() => handleDelete(data._id)} color="error">
              <DeleteIcon />
            </IconButton>
          </MDBox>
        ),
      }));

      return { columns, rows };
    }
  } catch (error) {
    console.error("Error fetching coupouns data:", error);
    return { columns, rows: [] };
  }
};

export default fetchCouponData;
